var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetSalesGenius = function SvgZetSalesGenius(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zetSalesGenius_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__b)",
    fillRule: "evenodd",
    d: "M23.37 1.67a10.962 10.962 0 0 1 4.78 9.09c0 3.01-1.19 5.73-3.12 7.7s-4.6 3.19-7.54 3.19-5.61-1.22-7.54-3.19a10.96 10.96 0 0 1-3.12-7.7c0-3.01 1.19-5.73 3.12-7.7.51-.52 1.08-.99 1.68-1.4v.17c-.57.39-1.1.84-1.58 1.33-1.91 1.94-3.08 4.63-3.08 7.6s1.18 5.66 3.08 7.6 4.54 3.15 7.44 3.15 5.54-1.2 7.44-3.15c1.91-1.94 3.08-4.63 3.08-7.6s-1.18-5.66-3.08-7.6c-.48-.49-1-.93-1.56-1.31v-.18M14.7 23.94c.38-.02 2.05-.2 1.91-2 0 0-2.02-.08-1.99 1.96.22-.36.51-.69.82-1 .33-.32.7-.63 1.08-.93l.05.07c-.37.3-.74.6-1.07.93-.31.3-.59.62-.81.98zm1.07-5.14c.04.41.15.82.29 1.23.16.44.35.87.56 1.3l-.08.04c-.2-.44-.4-.87-.56-1.31a5 5 0 0 1-.3-1.25c-.93 1.82.92 2.62.92 2.62.92-1.55-.5-2.44-.84-2.62zM13.12.98c-.25.12-.49.24-.72.37-.17.1-.34.21-.49.34 1.14.22 1.2-.65 1.21-.71m-1.2.64c.03-.21.19-.74 1.1-.65-.22.11-.44.22-.65.34-.16.09-.31.2-.45.31M12.01.5c-.14.23-.28.46-.44.68-.12.16-.25.32-.38.45-.12-1.14.76-1.13.83-1.13zm-.75 1.13c.13-.13.24-.27.35-.42.14-.19.27-.4.4-.61.02.91-.54 1.03-.75 1.04zm.71.74c-.25.12-.49.24-.72.37-.17.1-.34.21-.49.34 1.14.22 1.2-.65 1.21-.71m-1.2.64c.14-.11.29-.22.45-.31.21-.12.43-.23.65-.34-.91-.09-1.08.44-1.1.65m.08-1.9c-.07 0-.94.15-.62 1.26q.165-.24.3-.51c.12-.24.22-.49.31-.74zm-.54 1.24c.21-.05.74-.26.56-1.15-.09.23-.18.46-.29.67q-.12.255-.27.48m-.52-.67c-.07.02-1.01.37-.42 1.53.09-.21.16-.42.22-.64.08-.29.14-.59.19-.9zm-.33 1.5c.23-.1.77-.44.37-1.4-.05.28-.1.55-.17.81-.05.2-.12.4-.2.59m1.41.27c-.29.14-.59.29-.86.45-.21.12-.4.26-.58.41 1.36.26 1.44-.77 1.44-.85zm-1.44.76c.17-.14.35-.26.54-.37.25-.15.51-.28.78-.41-1.09-.11-1.29.53-1.32.78m-.59-1.45c-.08.02-1.06.39-.44 1.6.1-.21.17-.44.23-.67.08-.3.14-.62.2-.94zM8.5 4.33c.24-.1.8-.47.39-1.47-.05.29-.11.58-.18.85-.06.21-.12.42-.21.62m1.31.44c-.27.18-.54.37-.78.57-.19.15-.36.31-.52.49 1.39.06 1.3-.98 1.3-1.06m-1.3.97q.225-.24.48-.45c.22-.18.46-.35.71-.52-1.1.05-1.19.71-1.19.97m-.84-1.95c-.07.05-.98.73.06 1.81.03-.26.04-.51.03-.77a9 9 0 0 0-.1-1.04zm.15 1.74c.21-.18.68-.73-.06-1.65.04.32.07.63.08.94 0 .24 0 .47-.02.71m-.99-.18c-.07.06-.92.89.31 1.86 0-.27-.03-.54-.07-.8-.06-.35-.15-.71-.24-1.06m.39 1.78c.19-.22.61-.85-.29-1.7.08.32.16.65.21.97.04.25.07.49.07.74zm1.86-.93c-.29.26-.56.53-.82.81-.19.21-.37.43-.52.67C9.38 7.5 9.1 6.29 9.07 6.2zM7.72 7.57c.14-.21.31-.42.48-.61.23-.25.48-.5.74-.74-1.28.26-1.27 1.05-1.22 1.35m-1.58-.83c.14.39.28.78.39 1.17.08.3.14.6.17.89-1.49-.96-.62-1.99-.55-2.06zm.64 1.97c.2-.26.6-1.03-.51-1.89.13.36.25.71.35 1.07.07.27.13.55.16.82m1.88-.85c-.27.32-.53.65-.75.98-.17.26-.33.52-.46.79 1.73-.42 1.25-1.68 1.21-1.77M7.41 9.52c.12-.25.27-.49.43-.72.21-.3.44-.6.68-.9-1.33.46-1.21 1.31-1.11 1.62m-1.79-.87c-.05.09-.7 1.26.95 1.93-.09-.3-.21-.58-.34-.85-.18-.36-.39-.72-.61-1.08m1.01 1.82c.14-.3.38-1.12-.87-1.76.2.33.39.65.55.98.13.25.24.51.32.78m1.88-.8c-.27.32-.53.65-.75.98-.17.26-.33.52-.46.79 1.73-.42 1.25-1.68 1.21-1.77m-1.25 1.66c.12-.25.27-.49.43-.73.21-.3.44-.6.68-.9-1.33.46-1.21 1.31-1.11 1.62zm-1.91-.8c.28.31.55.63.79.95.18.25.35.5.49.77-1.74-.36-1.31-1.63-1.28-1.72m1.32 1.61c-.13-.24-.29-.48-.46-.71-.22-.3-.46-.58-.72-.87 1.35.41 1.26 1.26 1.17 1.58zm2.08-.81c-.27.32-.53.65-.75.98-.17.26-.33.52-.46.79 1.73-.42 1.25-1.68 1.21-1.77M7.5 12.99c.12-.25.27-.49.43-.73.21-.3.44-.6.68-.9-1.33.46-1.21 1.31-1.11 1.62zm-2.19-.52c0 .1-.1 1.44 1.68 1.35-.2-.23-.43-.44-.67-.63-.32-.25-.66-.49-1.01-.72M7 13.7c0-.33-.13-1.18-1.54-1.23.32.21.63.43.92.66.22.18.43.37.62.57m1.98-.6c-.17.33-.29.68-.37 1.06q-.135.6-.21 1.23h-.08c.06-.43.12-.85.21-1.25.09-.38.21-.74.38-1.08-1.58.92-.58 2.4-.58 2.4 1.44-.72.81-2.06.65-2.36m-3.24 2.96c.21.26 1.21 1.36 2.45.34 0 0-.98-1.48-2.46-.41.38-.03.77 0 1.15.07.41.07.82.18 1.24.29l-.02.07c-.41-.11-.82-.22-1.23-.29-.38-.07-.76-.1-1.13-.07m.82 1.84c.26.23 1.47 1.15 2.53-.11 0 0-1.27-1.32-2.56.03.38-.1.78-.13 1.18-.14.43 0 .86.03 1.3.07v.08c-.44-.04-.88-.07-1.3-.07-.4 0-.78.04-1.15.13zm2.97-3.13c-.08.39-.09.8-.07 1.22.02.45.09.9.16 1.35h-.08c-.07-.45-.13-.9-.16-1.35-.02-.42 0-.84.07-1.24-1.37 1.44.13 2.68.13 2.68 1.28-1.19.21-2.4-.05-2.66m-1.89 4.75c.31.2 1.72 1 2.65-.49 0 0-1.53-1.2-2.69.41.39-.16.8-.25 1.22-.32.45-.07.91-.09 1.38-.12v.08c-.46.02-.92.05-1.37.12-.42.06-.82.15-1.2.31zM8.98 21c.35.14 1.94.69 2.6-.99 0 0-1.79-.93-2.65.92.36-.23.76-.41 1.18-.55.44-.15.91-.27 1.38-.38l.02.08c-.47.11-.93.23-1.37.38-.41.14-.8.31-1.15.54zm1.72-4.6c-.02.4.03.81.11 1.22.09.44.22.88.35 1.32l-.08.02c-.14-.44-.27-.89-.36-1.32a5.3 5.3 0 0 1-.11-1.24c-1.14 1.62.52 2.63.52 2.63 1.1-1.36-.15-2.41-.44-2.62zm.1 5.82c.37.1 2.01.45 2.45-1.3 0 0-1.89-.71-2.51 1.24.33-.28.7-.5 1.1-.69.42-.2.87-.38 1.32-.55l.03.08c-.45.17-.9.34-1.32.55-.39.19-.76.41-1.08.68zm1.33-4.49c.07.41.2.81.38 1.21.18.42.41.84.64 1.26l-.08.04a17 17 0 0 1-.65-1.27c-.18-.4-.31-.81-.38-1.23-.81 1.88 1.09 2.56 1.09 2.56.82-1.61-.66-2.41-1.01-2.56zm.61 5.37c.38.04 2.06.12 2.21-1.67 0 0-1.98-.4-2.28 1.62.28-.32.61-.6.97-.86.38-.27.8-.51 1.22-.75l.04.07c-.42.24-.83.48-1.21.75-.36.25-.68.52-.95.84m1.15-4.53c.09.41.25.8.44 1.18.21.41.46.82.71 1.22l-.07.04c-.26-.41-.51-.81-.72-1.23-.2-.39-.36-.79-.45-1.21-.7 1.92 1.24 2.49 1.24 2.49.72-1.65-.8-2.36-1.16-2.5zm-8.41-4.38c.01.1.24 1.42 1.95.93a5 5 0 0 0-.8-.46c-.37-.17-.76-.32-1.15-.47m1.93.8c-.08-.32-.41-1.11-1.79-.84.36.13.71.27 1.05.43.26.12.51.26.74.41m12.93 8.95c-.38-.02-2.05-.2-1.91-2 0 0 2.02-.08 1.99 1.96-.22-.36-.51-.69-.82-1-.33-.32-.7-.63-1.08-.93l-.05.07c.37.3.74.6 1.07.93.31.3.59.62.81.98zm-1.07-5.14c-.33.18-1.76 1.07-.84 2.62 0 0 1.85-.8.92-2.62-.04.42-.15.84-.3 1.25-.16.44-.36.87-.56 1.31l-.08-.04c.2-.43.4-.86.56-1.3.15-.41.25-.81.29-1.23zM21.88.98c0 .07.07.93 1.21.72a3.6 3.6 0 0 0-.49-.35c-.23-.14-.47-.26-.72-.37m1.2.64c-.14-.11-.29-.22-.45-.31-.21-.12-.43-.23-.65-.34.91-.09 1.08.44 1.1.65M22.99.5c.07 0 .95-.01.83 1.13-.14-.14-.27-.29-.38-.45-.16-.21-.3-.44-.44-.68zm.75 1.13c-.22-.01-.77-.13-.75-1.04.13.21.26.42.4.61.11.15.23.29.35.42zm-.71.74c0 .07.07.93 1.21.72a3.6 3.6 0 0 0-.49-.35c-.23-.14-.47-.26-.72-.37m1.2.64c-.03-.21-.19-.74-1.1-.65.22.11.44.22.65.34.16.09.31.2.45.31m-.08-1.9c.1.25.2.5.31.74q.135.27.3.51c.32-1.11-.55-1.25-.62-1.25zm.54 1.24q-.15-.225-.27-.48c-.11-.22-.2-.44-.29-.67-.18.89.35 1.1.56 1.15m.52-.67c.05.3.11.61.19.9.06.22.13.43.22.64.6-1.16-.34-1.51-.42-1.53zm.33 1.5c-.08-.19-.15-.39-.2-.59-.07-.26-.12-.54-.17-.81-.39.96.15 1.3.37 1.4m-1.41.27c0 .08.08 1.12 1.44.86-.18-.16-.38-.29-.58-.41-.27-.16-.56-.31-.86-.45m1.44.76c-.03-.25-.23-.89-1.32-.78.27.13.53.26.78.41.19.11.37.24.54.37m.59-1.45c.06.32.12.63.2.94.06.23.14.45.23.67.62-1.22-.36-1.58-.44-1.6zm.34 1.57c-.08-.2-.15-.4-.21-.62-.07-.28-.13-.56-.18-.85-.41 1 .16 1.36.39 1.47m-1.31.44c0 .08-.09 1.12 1.3 1.07-.15-.18-.33-.34-.52-.5q-.375-.3-.78-.57m1.3.97c0-.26-.09-.92-1.19-.97.25.17.49.34.71.52q.255.21.48.45m.84-1.95c-.04.35-.08.69-.1 1.04 0 .26 0 .52.03.77 1.04-1.07.13-1.75.06-1.8zm-.15 1.74c-.03-.23-.03-.47-.02-.71.01-.31.05-.63.08-.94-.75.91-.28 1.47-.06 1.65m.99-.18c-.09.36-.18.71-.24 1.06-.05.27-.07.53-.07.8 1.22-.97.37-1.8.31-1.86m-.39 1.78c0-.24.03-.49.07-.74.05-.32.13-.64.21-.97-.9.85-.48 1.49-.29 1.7zm-1.86-.93c-.02.09-.31 1.3 1.33 1.49a5.6 5.6 0 0 0-.52-.68c-.25-.28-.53-.55-.82-.81zm1.36 1.37c.05-.3.06-1.1-1.22-1.35.26.24.51.49.74.74.18.2.34.4.48.61m1.58-.83c.07.08.94 1.1-.55 2.07.03-.31.09-.6.17-.9.1-.39.24-.78.39-1.17zm-.64 1.97c.03-.28.09-.55.16-.82.1-.36.22-.71.35-1.07-1.11.86-.71 1.63-.51 1.89m-1.88-.85c-.04.09-.52 1.35 1.21 1.78-.13-.28-.28-.54-.46-.8-.23-.34-.49-.66-.75-.98m1.25 1.66c.1-.31.22-1.16-1.11-1.62.24.29.47.59.68.9.16.23.31.48.43.72m1.79-.87c-.22.36-.43.71-.61 1.08-.14.28-.25.56-.34.84 1.65-.66 1-1.83.95-1.92m-1.01 1.82c.09-.26.2-.52.32-.78.16-.33.35-.66.55-.98-1.26.64-1.01 1.46-.87 1.76m-1.88-.8c-.04.09-.52 1.35 1.21 1.78-.13-.28-.28-.54-.46-.8-.23-.34-.49-.66-.75-.98m1.25 1.66c.1-.31.22-1.16-1.11-1.62.24.29.47.59.68.9.16.23.31.48.43.73zm1.91-.8c.04.1.47 1.37-1.28 1.73.14-.28.3-.53.49-.78.24-.33.51-.64.79-.95m-1.32 1.61c-.09-.32-.18-1.17 1.17-1.58-.25.29-.5.57-.72.87-.17.23-.32.46-.46.71zm-2.08-.81c-.04.09-.52 1.35 1.21 1.78-.13-.28-.28-.54-.46-.8-.23-.34-.49-.66-.75-.98m1.25 1.66c.1-.31.22-1.16-1.11-1.62.24.3.47.59.68.9.16.23.31.48.43.73zm2.19-.52c-.35.23-.69.47-1.01.72-.24.19-.47.4-.67.62 1.78.09 1.69-1.24 1.68-1.34M28 13.7c.19-.2.4-.39.62-.57.29-.23.6-.45.92-.66-1.41.05-1.54.9-1.54 1.23m-1.98-.6c-.16.29-.79 1.63.65 2.36 0 0 1-1.47-.58-2.4.17.34.29.7.38 1.08.09.4.16.82.21 1.24h-.08c-.06-.41-.12-.82-.21-1.22-.09-.37-.2-.73-.37-1.06m3.24 2.96c-.37-.03-.75 0-1.13.07-.41.07-.82.18-1.23.29l-.02-.07c.42-.11.83-.22 1.24-.29.39-.07.77-.1 1.15-.07-1.48-1.07-2.46.41-2.46.41 1.24 1.03 2.24-.07 2.45-.34m-.82 1.84c-.37-.09-.76-.13-1.15-.13-.43 0-.86.03-1.3.07v-.08c.43-.04.87-.07 1.3-.07.4 0 .8.04 1.18.14-1.29-1.35-2.56-.03-2.56-.03 1.06 1.26 2.27.33 2.53.11zm-2.97-3.13c-.26.26-1.33 1.47-.05 2.66 0 0 1.49-1.24.13-2.68.08.41.09.82.07 1.24-.02.45-.09.9-.16 1.36h-.08c.07-.47.13-.92.16-1.37.02-.42 0-.82-.07-1.22zm1.89 4.75c-.38-.15-.78-.25-1.2-.31-.45-.07-.91-.09-1.38-.12v-.08c.47.02.94.05 1.39.12.42.06.84.16 1.22.32-1.15-1.61-2.69-.41-2.69-.41.93 1.48 2.34.68 2.65.49zM26.02 21c-.35-.23-.74-.4-1.16-.54-.44-.15-.91-.27-1.37-.38l.02-.08c.47.11.94.23 1.38.38.42.14.82.32 1.18.55-.86-1.86-2.65-.92-2.65-.92.65 1.68 2.25 1.14 2.6.99m-1.72-4.6c-.29.22-1.53 1.26-.44 2.62 0 0 1.66-1.01.52-2.63.02.41-.03.83-.11 1.24-.09.44-.22.88-.36 1.32l-.08-.02c.13-.44.27-.88.35-1.32.08-.41.13-.81.11-1.22zm-.1 5.82a5.2 5.2 0 0 0-1.08-.68c-.42-.2-.87-.38-1.32-.55l.03-.08c.45.17.9.34 1.32.55.4.19.77.42 1.1.69-.62-1.95-2.51-1.24-2.51-1.24.44 1.75 2.08 1.4 2.45 1.3zm-1.33-4.49c-.34.16-1.82.95-1.01 2.56 0 0 1.9-.68 1.09-2.56-.07.42-.21.83-.38 1.23-.19.42-.41.85-.65 1.27l-.07-.04c.23-.42.46-.84.64-1.26.17-.39.31-.8.38-1.21zm-.61 5.37c-.27-.32-.6-.59-.95-.84-.38-.27-.79-.51-1.21-.75l.04-.07c.42.24.84.48 1.22.75.36.25.69.53.97.86-.3-2.02-2.28-1.62-2.28-1.62.15 1.79 1.83 1.71 2.21 1.67m-1.15-4.53c-.35.14-1.88.85-1.16 2.5 0 0 1.94-.57 1.24-2.49-.09.42-.25.82-.45 1.21-.21.41-.46.82-.72 1.23l-.07-.04c.25-.4.51-.81.71-1.22.19-.38.35-.78.44-1.18zm8.41-4.38c-.4.15-.78.3-1.15.47-.28.13-.55.28-.8.45 1.71.5 1.94-.82 1.95-.92m-1.93.8c.23-.15.48-.29.74-.41.34-.16.69-.3 1.05-.43-1.38-.27-1.71.52-1.79.84",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__c)",
    fillRule: "evenodd",
    d: "M9.251 3.31c-2.1 8.43-.47 16.72 8.25 20.88 8.72-4.16 10.35-12.44 8.25-20.88-2.16-.06-4.12-.54-5.6-1.27-.85.09-1.72.13-2.62.13h-.06c-.9 0-1.78-.04-2.62-.13-1.48.74-3.44 1.21-5.6 1.27",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__d)",
    fillRule: "evenodd",
    d: "M17.5 23.43C8.09 18.75 8.54 9.46 9.8 3.98c1.91-.12 3.72-.55 5.17-1.23q1.23.12 2.49.12h.06c.84 0 1.68-.04 2.5-.12 1.45.68 3.26 1.12 5.17 1.23 1.27 5.48 1.72 14.76-7.7 19.45z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__e)",
    fillRule: "evenodd",
    d: "M17.5 23.12c-4.01-2.03-6.56-5.12-7.58-9.19-.89-3.54-.45-7.19.11-9.7 1.85-.13 3.57-.55 5-1.21.8.07 1.62.11 2.44.11h.06c.82 0 1.64-.04 2.45-.11 1.43.66 3.15 1.08 5 1.21.56 2.5 1.01 6.15.11 9.7-1.02 4.06-3.58 7.15-7.58 9.19z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__f)",
    d: "M24.09 8.88h-5.3l.68 1.53h1.57v3.44h1.5v-3.44h1.56V8.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__g)",
    d: "M16.07 8.88h-4.28v1.53h2.07l-2.07 1.91v1.53h4.28v-1.53H14l2.07-1.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__h)",
    d: "M19.97 12.32h-2.18v-.26h2.06l-.39-.86-.24-.52h-1.44v-.26h1.3l-.68-1.53h-1.99v4.97h4.25l-.7-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__i)",
    d: "M.5 17.59c.36.18.84.46 1.31.89.58.52.92 1.06 1.12 1.43L.5 22.68c1.39-.98 8.68.98 8.68-.5.13-.44-2.35-4.92-3.39-4.9 0 0-5.06-.39-5.29.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__j)",
    d: "M9.18 22.05c-.32-.71-3.36.75-3.64-.55 0 0-.25-1.41 3.43-.88l.21 1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__k)",
    d: "M34.5 17.42c-.36.18-.84.46-1.31.89-.58.52-.92 1.06-1.12 1.43.81.92 1.62 1.85 2.43 2.77-1.39-.98-8.68.98-8.68-.5-.13-.44 2.35-4.92 3.39-4.9 0 0 5.06-.39 5.29.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__l)",
    d: "M25.82 21.89c.32-.71 3.36.75 3.64-.55 0 0 .25-1.41-3.43-.88l-.21 1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetSalesGenius_svg__m)",
    d: "M17.5 16.96c8.41 0 11.22-2.01 11.96-.91v5.29c-.25-1.2-4.63 1.07-11.96 1.07S5.79 20.15 5.54 21.34v-5.29c.74-1.1 3.55.91 11.96.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D1A0D",
    d: "M7.87 19.74c0 .06.05.11.1.11h.39a.1.1 0 0 0 .1-.1v-.09c0-.1-.03-.13-.14-.13l-.55-.02c-.29-.01-.39-.16-.39-.35v-.58c0-.2.1-.35.39-.35h.86c.29 0 .39.16.39.35v.12c0 .06-.02.08-.08.09l-.4.08c-.06.01-.08 0-.08-.06 0-.04-.05-.09-.1-.09h-.31a.1.1 0 0 0-.1.1v.05c0 .11.04.13.14.14l.55.02c.29.01.39.16.39.36V20c0 .2-.1.35-.39.35H7.7c-.29 0-.39-.16-.39-.35v-.14c0-.06.02-.08.08-.09l.4-.08c.06-.01.08 0 .08.06zM11.06 20.34h-.43c-.06 0-.08-.01-.1-.07l-.09-.26h-.66l-.09.26c-.02.06-.04.07-.1.07H9.2c-.06 0-.07-.02-.05-.07l.69-1.98c.02-.06.04-.07.1-.07h.37c.06 0 .08.01.11.07l.69 1.98c.02.06 0 .07-.05.07m-.78-.82-.11-.35-.06-.21-.06.21-.11.35zM12.74 19.93v.34c0 .06-.02.08-.08.08H11.4c-.06 0-.08-.02-.08-.08V18.3c0-.06.02-.08.08-.08h.41c.06 0 .08.02.08.08v1.56h.78c.06 0 .08.02.08.08zM14.4 19.93v.34c0 .06-.02.08-.08.08h-1.3c-.06 0-.08-.02-.08-.08V18.3c0-.06.02-.08.08-.08h1.25c.06 0 .08.02.08.08v.34c0 .06-.02.08-.08.08h-.76v.31h.48c.06 0 .08.02.08.08v.35c0 .06-.02.08-.08.08h-.48v.33h.81c.06 0 .08.02.08.08zM15.13 19.74c0 .06.05.11.1.11h.39a.1.1 0 0 0 .1-.1v-.09c0-.1-.03-.13-.14-.13l-.55-.02c-.29-.01-.39-.16-.39-.35v-.58c0-.2.1-.35.39-.35h.86c.29 0 .39.16.39.35v.12c0 .06-.02.08-.08.09l-.4.08c-.06.01-.08 0-.08-.06 0-.04-.05-.09-.1-.09h-.31a.1.1 0 0 0-.1.1v.05c0 .11.04.13.14.14l.55.02c.29.01.39.16.39.36V20c0 .2-.1.35-.39.35h-.94c-.29 0-.39-.16-.39-.35v-.14c0-.06.02-.08.08-.09l.4-.08c.06-.01.08 0 .08.06zM18.52 19.85v-.29h-.26c-.06 0-.08-.02-.08-.08v-.34c0-.06.02-.08.08-.08H19c.06 0 .08.02.08.08v.85c0 .2-.1.35-.39.35h-1.02c-.29 0-.39-.16-.39-.35v-1.42c0-.2.1-.35.39-.35h1.02c.29 0 .39.16.39.35v.13c0 .06-.01.08-.08.09l-.4.07c-.06.01-.08 0-.08-.06v-.1h-.67v1.15zM20.86 19.93v.34c0 .06-.02.08-.08.08h-1.29c-.06 0-.08-.02-.08-.08V18.3c0-.06.02-.08.08-.08h1.25c.06 0 .08.02.08.08v.34c0 .06-.02.08-.08.08h-.76v.31h.48c.06 0 .08.02.08.08v.35c0 .06-.02.08-.08.08h-.48v.33h.81c.06 0 .08.02.08.08zM22.34 20.28l-.69-1.09v1.08c0 .06-.02.08-.08.08h-.39c-.06 0-.08-.02-.08-.08V18.3c0-.06.02-.08.08-.08h.36c.06 0 .09.01.12.07l.65 1.02V18.3c0-.06.02-.08.08-.08h.39c.06 0 .08.02.08.08v1.97c0 .06-.02.08-.08.08h-.32c-.06 0-.09-.01-.12-.07M23.31 18.21h.41c.06 0 .08.02.08.08v1.97c0 .06-.02.08-.08.08h-.41c-.06 0-.08-.02-.08-.08v-1.97c0-.06.02-.08.08-.08M24.16 19.99v-1.7c0-.06.02-.08.08-.08h.41c.06 0 .08.02.08.08v1.55h.58v-1.55c0-.06.02-.08.08-.08h.41c.06 0 .08.02.08.08v1.7c0 .2-.09.35-.38.35h-.95c-.29 0-.39-.16-.39-.35M26.71 19.74c0 .06.05.11.1.11h.39a.1.1 0 0 0 .1-.1v-.09c0-.1-.03-.13-.14-.13l-.55-.02c-.29-.01-.39-.16-.39-.35v-.58c0-.2.1-.35.39-.35h.86c.29 0 .39.16.39.35v.12c0 .06-.02.08-.08.09l-.4.08c-.06.01-.08 0-.08-.06 0-.04-.05-.09-.1-.09h-.31a.1.1 0 0 0-.1.1v.05c0 .11.04.13.14.14l.55.02c.29.01.39.16.39.36V20c0 .2-.1.35-.39.35h-.94c-.29 0-.39-.16-.39-.35v-.14c0-.06.02-.08.08-.09l.4-.08c.06-.01.08 0 .08.06z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__c",
    x1: 8.421,
    x2: 26.581,
    y1: 13.12,
    y2: 13.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BE912D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C39836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CCA546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D7B75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E7CE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F9EA9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F7E79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2C772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D2AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C69D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B58526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8C5212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3F0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__d",
    x1: 17.5,
    x2: 17.5,
    y1: 23.43,
    y2: 2.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BE912D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C39836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CCA546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D7B75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E7CE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F9EA9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F7E79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2C772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D2AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C69D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B58526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8C5212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3F0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__e",
    x1: 9.409,
    x2: 25.59,
    y1: 13.069,
    y2: 13.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#754C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#684324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#472C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__f",
    x1: 11.059,
    x2: 43.269,
    y1: 11.47,
    y2: 11.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77411B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B9914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A98533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__g",
    x1: 5.549,
    x2: 31.559,
    y1: 11.44,
    y2: 11.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77411B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B9914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A98533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__h",
    x1: 10.22,
    x2: 36.03,
    y1: 11.44,
    y2: 11.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77411B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B9914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A98533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__i",
    x1: 0.5,
    x2: 9.19,
    y1: 19.96,
    y2: 19.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77411B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B9914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2BB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#DBB45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CEA853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BC9743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A98533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__j",
    x1: 5.541,
    x2: 9.181,
    y1: 21.29,
    y2: 21.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E1F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#814C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2E1F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__k",
    x1: 34.499,
    x2: 25.809,
    y1: 19.8,
    y2: 19.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77411B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B9914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2BB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#DBB45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CEA853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BC9743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A98533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__l",
    x1: 29.46,
    x2: 25.82,
    y1: 21.12,
    y2: 21.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E1F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#814C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2E1F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#381A19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetSalesGenius_svg__m",
    x1: 5.529,
    x2: 29.459,
    y1: 19.06,
    y2: 19.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BE912D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C39836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CCA546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D7B75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E7CE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F9EA9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F7E79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2C772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D2AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C69D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B58526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8C5212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3F0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "zetSalesGenius_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.7 0 0 30.36 20.122 11.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8C5212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B58526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BD8F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C69D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D2AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E2C772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F7E79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FEF1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9EA9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E7CE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D7B75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CCA546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#C39836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#BE912D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD8F2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zetSalesGenius_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v25H0z"
  })))));
};
export default SvgZetSalesGenius;